// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'viewerjs/dist/viewer.css'
import './assets/css/common.less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/icon-font/iconfont.css'
import '@/assets/font/iconfont.css'
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import store from "./store"
import {GetAxios, PostAxios, baseUrl} from '../static/js/common.js'
import Viewer from 'v-viewer'
import echarts from 'echarts'
import 'echarts-liquidfill'

Vue.prototype.$echarts = echarts
import 'echarts/map/js/world.js';
import 'echarts/map/js/china.js';
import 'echarts/extension-src/bmap/bmap.js';
import router from './router'
// import preventReClick from '../static/js/preventReClick' //防多次点击，重复提交
import VueQriously from 'vue-qriously'

// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
//
// Vue.use(VueQuillEditor);

Vue.use(VueQriously)


Vue.use(ElementUI);
Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

Vue.prototype.GetAxios = GetAxios;
Vue.prototype.PostAxios = PostAxios;
Vue.use(Viewer);


Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})


// 禁止空格输入
window.onkeypress = (event) => {
  if (event.keyCode == 32) event.returnValue = false
}
router.beforeEach((to, from, next) => {

  if (store.state.role !== '' && store.state.role !== undefined) {
    return next()
  } else if (sessionStorage.getItem("store_role") !== "undefined" && sessionStorage.getItem("store_role") !== null) {
    // store_msg为对象,需要json转化
    // console.log("获取到的缓存:", sessionStorage.getItem("store_role"))
    store.state.msg = JSON.parse(sessionStorage.getItem("store_msg"));
    store.state.role = sessionStorage.getItem("store_role");
    return next()
  } else {
    PostAxios({url: '/users/rolelist/'}).then(res => {
      store.state.msg = res.data;
      store.state.role = res.role;
      // store_msg为对象,需要json转化
      sessionStorage.setItem("store_msg", JSON.stringify(res.data));
      sessionStorage.setItem("store_role", res.role);
      sessionStorage.setItem("user_id", res.user_id);
      return next()
    })
  }
})


Vue.prototype.baseUrl = baseUrl;
/* eslint-disable no-new */
const sVue = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  data: function () {
    return {
      unreadmsgnumber: 0,
      numArr: 0   //代办总数
    }
  },
});
export const _this_ = sVue;




// WEBPACK FOOTER //
// ./src/main.js